import { render, staticRenderFns } from "./ServiceDashboardSection.vue?vue&type=template&id=dbda809c&scoped=true&"
import script from "./ServiceDashboardSection.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboardSection.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDashboardSection.vue?vue&type=style&index=0&id=dbda809c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbda809c",
  null
  
)

export default component.exports